<p class="alert alert-info" style="max-width: 600px" [class.invalid-feedback]="showError" *ngIf="model.parent">
  <nb-icon icon="link-2-outline"></nb-icon>
  {{ props.label }}
  /
  <a (click)="showProduct(model.parent.id)" [routerLink]="['/cabinet/pim/catalog/item/edit/', model.parent.id]">{{ model.parent.header }}</a>
</p>
